// Контрольные точки для адаптивного дизайна.
export const Breakpoint = {
  mobile: 570,

  tabletPortrait: 700,

  tabletAlbum: 1013,

  desktop: 1100,
};

// Поддерживаемые языки.
export const langs = [
  {
    code: 'en',
  },
  {
    code: 'ru',
  },
] as const;

// Язык по умолчанию.
export const DEFAULT_LANG: (typeof langs)[number]['code'] = 'ru';
